import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import { useSelector, useDispatch } from 'react-redux';


//****** END MENU OBJECT ****************

const ProjNavСhain = (props) => {
  const dispatch = useDispatch();
  
  
  const fncLogOut = props.fncLogOut
  
  const [isOpen, setIsOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  //const [breadcrumbs, setBreadcrumbs] = useState([]);
  //const [menuData, setMenuData] = useState([]);

  const location = useLocation();
  const  allProjects = useSelector((state) => state.dev.all_projects);
  const  selectedProjectDesks = useSelector((state) => state.dev.selected_project_desks);
  const  selectedDesk = useSelector((state) => state.dev.selected_desk);

  useEffect(() => {
    //setMenuData(menuDataR)
    //console.log('Navbar useEffect')
    //console.log(location)
   }, [])

/*    console.log(allProjects)
   console.log(selectedProjectDesks)
   console.log(selectedDesk) */
   

   const navObject = () => {
    const breadcrumbs = [];
    breadcrumbs[0] = {id: 1, name: 'Projects', path: `/projects`}
/*     if (Object.keys(selectedDesk).length) {
      //console.log(selectedDesk['project_info'])
      const project_id = selectedDesk['project_info'].id;
      const project_name = selectedDesk['project_info'].name
      breadcrumbs[0] = {project_id: project_id, name: project_name, path: `/selected_project/${project_id}`}
      
      console.log(selectedDesk['desk_info'])
      const desk_id = selectedDesk['desk_info'][0].id;
      const desk_name = selectedDesk['desk_info'][0].desk_name
      breadcrumbs[1] = {desk_id: desk_id, name: desk_name, path: `/selected_desk/${desk_id}`}

    } */

      if (Object.keys(selectedDesk).length) {
        //console.log(selectedDesk['project_info'])
        const project_id = selectedDesk['project_info'].id;
        const project_name = selectedDesk['project_info'].name
        breadcrumbs[1] = {id: project_id, name: project_name, path: `/selected_project/${project_id}`}
        
        //console.log(selectedDesk['desk_info'])
        const desk_id = selectedDesk['desk_info'][0].id;
        const desk_name = selectedDesk['desk_info'][0].desk_name
        breadcrumbs[2] = {id: desk_id, name: desk_name, path: `/selected_desk/${desk_id}`}

        return breadcrumbs;
        //console.log('yyy')
      }
      
      if (Object.keys(selectedProjectDesks).length) {
        //console.log(selectedProjectDesks.project_id, selectedProjectDesks.projectName)
        const project_id = selectedProjectDesks.project_id;
        const project_name = selectedProjectDesks.projectName;
        breadcrumbs[1] = {project_id: project_id, name: project_name, path: `/selected_project/${project_id}`}

        return breadcrumbs;
        //console.log('eee')
      }

/*      let navObj = [
      {projectId: 1, name: "Projects", path: '/projects', selected: false, children: [
        {deskId: 1, name: "Quartz factory sensors", path: '/selected_desk/1', selected: false, children: [
          {name: null, path: null, children: []},
        ]},
        {deskId: 2, name: "Test2", path: '/selected_desk/2', selected: false, children: [
          {name: null, path: null, children: []},
        ]}
      ]}
     ]
     
     breadcrumbs[0] = {project_id: 1, name: 'sss', path: '/test'}
     breadcrumbs[1] = {project_id: 2, name: 'sss2', path: '/test'}
     breadcrumbs[2] = {project_id: 3, name: 'sss3', path: '/test'}
     if (Object.keys(selectedDesk).length) {
       navObj = {...navObj, gg: 'ddd'}
     } */
     //console.log(breadcrumbs)
     return breadcrumbs; //<Link to={`/selected_project/${v.id}`}>Show me</Link>  <Link to={`${v.path}`}>Show me</Link>

   }

   //console.log(navObject())

  return (
    <div>
      {/* <p>ProjNavСhain</p> */}
      {navObject().map((v,i) => {
        let devider = <span></span>
        if (i !== 0) {
          devider = <span>{` > `}</span>
        }
        return <span key={`chain_${i}`}>{devider}<Link to={`${v.path}`}>{v.name}</Link></span>
      })}

    </div>
  );
};

export default ProjNavСhain;
